import React from 'react'

const ColourPicker = function () {
    return (<block type={'colour_picker'}></block>)
}

export default ColourPicker